var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrunchbaselogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#101527",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156 2238 c-52 -14 -128 -89 -144 -144 -17 -58 -17 -1864 0 -1932 15 -59 85 -132 144 -150 58 -17 1864 -17 1932 0 62 15 133 85 150 148 10 35 12 261 10 985 l-3 940 -22 42 c-29 53 -84 98 -139 112 -58 15 -1872 13 -1928 -1z m1154 -678 c0 -104 1 -190 3 -190 2 0 23 10 48 23 37 18 60 22 139 22 113 -1 168 -23 240 -95 172 -171 125 -448 -96 -556 -51 -25 -70 -29 -144 -29 -71 0 -94 4 -137 26 -49 24 -52 24 -57 7 -4 -17 -13 -19 -73 -16 l-68 3 -3 498 -2 497 75 0 75 0 0 -190z m-419 -172 c31 -14 73 -42 93 -63 39 -38 99 -151 90 -167 -3 -4 -36 -8 -73 -8 l-69 0 -36 44 c-86 106 -240 100 -317 -12 -17 -26 -24 -52 -27 -101 -3 -59 0 -71 26 -112 72 -113 232 -119 320 -14 l29 36 75 -3 76 -3 -20 -53 c-24 -65 -95 -139 -163 -172 -75 -35 -200 -40 -280 -9 -83 31 -175 122 -200 198 -53 160 3 331 136 416 94 61 237 70 340 23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456 1259 c-125 -30 -185 -182 -116 -294 51 -82 169 -113 257 -67 75 39 109 105 101 198 -10 114 -124 192 -242 163z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrunchbaselogo);
export default __webpack_public_path__ + "static/media/crunchbaselogo.a9af594853ca266dc86e67e9579f16b1.svg";
export { ForwardRef as ReactComponent };